export default "__VITE_ASSET__DQFnSuLE__"